export const FETCH_DESTINATIONS_REQUEST = "FETCH_DESTINATIONS_REQUEST";
export const FETCH_DESTINATIONS_SUCCESS = "FETCH_DESTINATIONS_SUCCESS";
export const FETCH_DESTINATIONS_FAILURE = "FETCH_DESTINATIONS_FAILURE";

export const DESTINATIONS_CLEARED = "DESTINATIONS_CLEARED";
export const DESTINATION_SELECTED = "DESTINATION_SELECTED";

export const VALIDATION_ERROR = "VALIDATION_ERROR";


